import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ApplyApplication.module.scss";
import logo from "../../assets/images/logo-big.png";
import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { useMutationByMethod } from "../../services/hooks/useMutationByMethod";
import { GetUrl, PostUrl } from "../../api/endpointConfig";
import { useLoader } from "../../Loader/LoaderContext";
import { ApplicantInterface } from "../../types/types";
import { useGet } from "../../services/hooks/useGet";
import { APP_MAINPAGE_URL } from "../../config/config";

const ApplyApplication: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [offsetValue, setOffsetValue] = useState<number>(0);
  const [limitValue, setLimitValue] = useState<number>(0);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [mainData, setMainData] = useState<ApplicantInterface[]>([]);
  const { showLoader, hideLoader } = useLoader();
  const navigate = useNavigate();
  const getApplicationData = useGet<any>(
    `${GetUrl.getApplicationAll}?offset=${offsetValue}&limit=${limitValue}`
  );
  const fetchApplicationData = async () => {
    showLoader();
    try {
      const result = await getApplicationData.refetch();
      hideLoader();
      if (result?.data?.data) {
        setMainData(result.data.data);
      }
    } catch (error) {
      hideLoader();
      console.error("Error fetching app version:", error);
    }
  };

  useEffect(() => {
    fetchApplicationData();
    localStorage.clear()
  }, []);
  const createAppMutation = useMutationByMethod<any>(
    "post",
    `${PostUrl.createApplication}?phone_number=${phoneNumber}`
  );
  const postAppCreateReq = async () => {
    showLoader();
    createAppMutation.mutate(null, {
      onSuccess: (data) => {
        hideLoader();
        console.log("data===", data);
        localStorage.setItem("applicationID", data.id);
        localStorage.setItem("mobileNumber", phoneNumber);
        localStorage.setItem("applicationStatus", "draft");
        navigate("/applicationcreate");
      },
      onError: (err) => {
        hideLoader();
        console.error("error", err);
      },
    });
  };
  const handleAddApplication = () => {
    if (!/^\d{10}$/.test(phoneNumber)) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }
    postAppCreateReq();
  };
  return (
    <Box className={styles.container}>
      <Box className={styles.centered}>
        {/* <Box className={styles.logoContainer}>
          <img src={logo} alt="Logo" className={styles.logo} />
        </Box> */}

        <Typography
          variant="h5"
          className={styles.sectionTitle}
          marginBottom={2}
          display={"flex"}
          justifyContent={"center"}
        >
          <span>Apply for Scholarship</span>
        </Typography>
        <Box className="form-group">
   
            <TextField
              fullWidth
              id="phoneNumber"
              name="phoneNumber"
              label="Enter Phone Number"
              value={phoneNumber}
              // onChange={(e) => setPhoneNumber(e.target.value)}
              onChange={(e) => {
                const val = e.target.value.replace(/\D/g, "");
                if (val.length <= 10) {
                  setPhoneNumber(e.target.value)
                }
              }}
              onBlur={() => {
                if (!/^\d{10}$/.test(phoneNumber)) {
                  alert("Please enter a valid 10-digit phone number.");
                }
              }}
              slotProps={{
                input: {
                  inputProps: {
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    maxLength: 10,
                  },
                },
              }}
            />
            <Typography
              variant="body2"
              sx={{
              backgroundColor: "#fff", // light yellow (MUI note color)
              color: "#0070D8", // brown text for contrast
              padding: "8px 12px",
              borderRadius: "4px",
              mb: 1,
              mt: 2,
              fontSize: "0.75rem",
              fontWeight: 700
              }}
            >
              Please Note: This phone number will be used to track the application status in future
            </Typography>
            {mainData.some((item) => item.phone_number === phoneNumber) &&
              phoneNumber && (
                <Typography color="error" mb={2} sx={{ fontSize: "0.75rem" }}>
                  This phone number already exists.
                </Typography>
              )}
            <Box display="flex" justifyContent="center" gap={1} mt={2}>
              <Button
                variant="outlined"
                color="info"
                onClick={() => window.location.href = APP_MAINPAGE_URL}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="info"
                onClick={handleAddApplication}
                disabled={
                  loading ||
                  !phoneNumber ||
                  mainData.some((item) => item.phone_number === phoneNumber)
                }
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </Box>
      </Box>
 
    </Box>
  );
};

export default ApplyApplication;
